import { Shaders, GLSL } from "gl-react";
const HeatGuideShader = () => {

  const shaders = Shaders.create({
    gradient: {
      frag: GLSL`
        precision highp float;
        varying vec2 uv;
        uniform vec3 colors[100];
        uniform int numColors;
    
        void main() {
    
          vec3 finalColor = colors[0];
          for (int i = 0; i < 100; i++) {
              if (i >= numColors) break;
              finalColor = mix(finalColor, colors[i], clamp((uv.y * float(numColors)) * -1.0 + float(numColors - i), 0.0, 1.0));
          }
                  
          gl_FragColor = vec4(finalColor, 1);
        }`
    }
  });

  return shaders.gradient;
}

export default HeatGuideShader;


